import * as types from './actionTypes'

export const initialState = {}

const fleetDetails = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_VEHICLE_DETAILS:
      return { ...payload }
    default:
      return state
  }
}

export default fleetDetails
